import {useSelector, useDispatch} from "react-redux";
import DraggableTree from "./DraggableTree";
import {selectObject, reorderObject, concealObject, revealObject, deleteObject} from "store/actions/asset";
import {selectLayerTab} from "store/actions/layer";
import {ReactComponent as Delete} from "assets/image/Layout/ObjectPanel/Layer/ic_delete.svg";
import styles from "./index.module.scss";
import _ from "lodash";
import CustomTooltip from "components/Common/Tooltip/CustomTooltip";
import {useIntl} from "react-intl";

export default function AssetLayer() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const layer = useSelector(state => state.layer);
  const scenes = useSelector(state => state.asset.scenes);
  const selectedKeys = useSelector(state => state.asset.selectedObjectKeys);

  if (_.isEmpty(scenes)) return null;

  return (
    <div className={styles.container}>
      <div className={styles.tab}>
        <button
          type="button"
          className={layer.currentTab === "world" ? styles.selected : undefined}
          onClick={() => dispatch(selectLayerTab("world"))}
        >
          World
        </button>
        <button
          type="button"
          className={layer.currentTab === "gui" ? styles.selected : undefined}
          onClick={() => dispatch(selectLayerTab("gui"))}
        >
          GUI
        </button>
      </div>
      <div className={styles.contents}>
        <DraggableTree
          tab={layer.currentTab}
          scene={layer.currentTab === "world" ? scenes.default : scenes.GUI}
          selectedKeys={selectedKeys}
          selectObject={selectObject}
          reorderObject={reorderObject}
          concealObject={concealObject}
          revealObject={revealObject}
        />
      </div>
      <footer className={styles.footer}>
        <CustomTooltip description={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_DELETE_BTN"})} placement={"top"}>
          <Delete onClick={() => dispatch(deleteObject())} />
        </CustomTooltip>
      </footer>
    </div>
  );
}
